import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsLastNameViewer = {
    autoComplete: 'family-name',
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map